import { TranslationsContext } from '@teliaee/telia-translate';
import React, { useContext } from 'react';
import { ListItem, List, THeadingLevel } from 'telia-front-react';
import B2BOfferCard from './B2BOfferCard';

interface Props {
  missing: boolean;
  formName: string;
  headingLevel?: THeadingLevel;
}

const B2BOfferInternetCard = (props: Props): JSX.Element => {
  const { translate } = useContext(TranslationsContext);
  const { missing, formName, headingLevel } = props;
  return (
    <B2BOfferCard missing={missing} mainIcon="#service-internet" suffix="internet" mobile={false} b2bInternetFormName={formName} headingLevel={headingLevel}>
      <List type="icon">
        <ListItem icon={missing ? '#percentage' : '#check'}>
          {translate(`personalOffers.b2b.${missing ? 'card.internet.join' : 'internet.already.using'}`)}
        </ListItem>
      </List>
    </B2BOfferCard>
  );
};
export default B2BOfferInternetCard;
